'use strict';
angular.module('initAddMetaDataModule', []).factory('initAddMetaDataService', [
    '$stateParams',
    'editingCenterAppService',
    function($stateParams, editingCenterAppService) {
        return {
            initNews: function() {
                var list = {
                    METADATAID: 0,
                    CHANNELID: $stateParams.appchannelid,
                    THUMB: 1,
                    LISTSTYLE: 0,
                    LISTTITLE: '',
                    LISTPICS: [],
                    LABEL: angular.copy(editingCenterAppService.initLabel()[0].value),
                    ISFOCUSIMAGE: 1,
                    FOCUSIMAGE: [],
                    NEWSSTYLE: '',
                    TITLE: '',
                    HTMLCONTENT: '',
                    CONTENT: '',
                    NEWSSOURCES: '',
                    CONTRIBUTORSAUTHER: '',
                    CONTRIBUTORSONE: angular.copy(editingCenterAppService.initContributorsOne()[0]),
                    CONTRIBUTORSTWO: angular.copy(editingCenterAppService.initContributorsOne()[0]),
                    CONTRIBUTORSTHREE: angular.copy(editingCenterAppService.initContributorsOne()[0]),
                    SIGNATUREAUTHOR: '',
                    KEYWORDS: '',
                    ABSTRACT: '',
                    ISSELECTFIGURE: 0,
                    FIGURE: [],
                    COMMENTSET: 1,
                    BELONGCHANNEL: {},
                    RELEVANTNEWSIDS: '',
                    RELEVANTOFFICIALSIDS: [],
                    ISNOPAYMENT: '1',
                    DOCGENRE: angular.copy(editingCenterAppService.initDocGenre()[0]),
                    FOCUSIMGTITLE: '',
                    FOCUSIMAGEDESC: '',
                    DOCWORDSCOUNT: 0,
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [{ isCreate: true }],
                    RELATEDNEWS: '',
                    RELEVANTSPECIALDOC: [],
                    ISCONTAINSENSITIVEWORDS: 0,
                    SENSITIVEWORDS: '',
                    // 额外参数
                    ORIGINAL: '0',
                    HIDDENLABEL: 0, // 签发后隐藏选项
                    RESPONSIBLEEDITOR: '', // 责任编辑
                    CUSTOMTIME: '', // 自定义发布时间
                };
                return list;
            },
            initAtlas: function() {
                var list = {
                    CHANNELID: $stateParams.appchannelid,
                    METADATAID: 0,
                    THUMB: 1,
                    LISTSTYLE: 0,
                    LISTPICS: [],
                    LABEL: angular.copy(editingCenterAppService.initLabel()[0].value),
                    ISFOCUSIMAGE: 1,
                    FOCUSIMAGE: [],
                    RELEASESOURCE: '',
                    SUBTITLE: '',
                    LEADTITLE: '',
                    NEWSSOURCES: '',
                    RELEVANTOFFICIALSIDS: [],
                    TEMPLATESETTING: '',
                    SIGNATUREAUTHOR: '',
                    CONTRIBUTORSAUTHER: '',
                    CONTRIBUTORSONE: angular.copy(editingCenterAppService.initContributorsOne()[0]),
                    CONTRIBUTORSTWO: angular.copy(editingCenterAppService.initContributorsOne()[0]),
                    CONTRIBUTORSTHREE: angular.copy(editingCenterAppService.initContributorsOne()[0]),
                    KEYWORDS: '',
                    ABSTRACT: '',
                    ISSELECTFIGURE: '',
                    FOCUSIMGTITLE: '',
                    FOCUSIMAGEDESC: '',
                    FIGURE: [],
                    COMMENTSET: 1,
                    DOC_PICTURELIST: [],
                    ISNOPAYMENT: '1',
                    DOCGENRE: angular.copy(editingCenterAppService.initDocGenre()[0]),
                    BELONGCHANNEL: {},
                    FLOWVERSIONTIME: '',
                    DOCTYPE: '',
                    DOCWORDSCOUNT: 0,
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [{ isCreate: true }],
                    RELATEDNEWS: '',
                    RELEVANTSPECIALDOC: [],
                    ISCONTAINSENSITIVEWORDS: 0,
                    SENSITIVEWORDS: '',
                    HIDDENLABEL: 0, // 签发后隐藏选项
                    RESPONSIBLEEDITOR: '', // 责任编辑
                    CUSTOMTIME: '', // 自定义发布时间
                };
                return list;
            },
            initSubject: function() {
                var list = {
                    CHANNELID: $stateParams.appchannelid,
                    METADATAID: 0,
                    LISTSTYLE: 0,
                    LISTTITLE: '',
                    LISTPICS: [],
                    LABEL: angular.copy(editingCenterAppService.initLabel()[0].value),
                    DISPLAYSET: 0,
                    TITLE: '',
                    FOCUSIMGTITLE: '',
                    FOCUSIMAGEDESC: '',
                    ISFOCUSIMAGE: 1,
                    FOCUSIMAGE: [],
                    KEYWORDS: '',
                    ABSTRACT: '',
                    // "ISSELECTFIGURE": 0,
                    FIGURE: [],
                    DOCWORDSCOUNT: 0,
                    FZ_SPECIALGROUPINFO: '',
                    ISCONTAINSENSITIVEWORDS: 0,
                    SENSITIVEWORDS: '',
                    ASSIGNNEWS: '',
                    ISNOPAYMENT: '1',
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [{ isCreate: true }],
                    ISFOCUSNEWS: 0,
                    FOCUSNEWSID: '',
                    FOCUSNEWSIMG: [],
                    BELONGCHANNEL: {},
                    HIDDENLABEL: 0, // 签发后隐藏选项
                    DOCGENRE: angular.copy(editingCenterAppService.initDocGenre()[0]),
                    RESPONSIBLEEDITOR: '', // 责任编辑
                    CUSTOMTIME: '', // 自定义发布时间
                };
                return list;
            },
            initWebsite: function() {
                var list = {
                    METADATAID: 0,
                    CHANNELID: $stateParams.appchannelid,
                    THUMB: 1,
                    LISTSTYLE: 0,
                    LISTTITLE: '',
                    LISTPICS: [],
                    RELEVANTOFFICIALSIDS: [],
                    LABEL: angular.copy(editingCenterAppService.initLabel()[0].value),
                    BELONGCHANNEL: {},
                    ISFOCUSIMAGE: 1,
                    FOCUSIMAGE: [],
                    URL: '',
                    COMMENTSET: 1,
                    DOCWORDSCOUNT: 0,
                    FOCUSIMGTITLE: '',
                    FOCUSIMAGEDESC: '',
                    RELEVANTSPECIALDOC: [],
                    ISCONTAINSENSITIVEWORDS: 0,
                    SENSITIVEWORDS: '',
                    HIDDENLABEL: 0, // 签发后隐藏选项
                    ISNOPAYMENT: '1',
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [{ isCreate: true }],
                    DOCGENRE: angular.copy(editingCenterAppService.initDocGenre()[0]),
                    CUSTOMTIME: '', // 自定义发布时间
                };
                return list;
            },
            initActivity: function() {
                var list = {
                    METADATAID: 0,
                    CHANNELID: $stateParams.appchannelid,
                    LISTTITLE: '',
                    LISTPICS: [],
                    THUMB: 1,
                    TOPICSTARTTIME: '',
                    TOPICENDTIME: '',
                    RELEVANTSPECIALDOC: [],
                    RELATEDNEWS: '',
                    ISFOCUSIMAGE: 1,
                    FOCUSIMGTITLE: '',
                    FOCUSIMAGE: [],
                    FOCUSIMAGEDESC: '',
                    MAXNUMBER: '',
                    VIRTUALINCREMENT: '',
                    PUBLIST: 0,
                    APPLYSETTING: {},
                    HTMLCONTENT: '',
                    CONTENT: '',
                    COMMENTSET: 1,
                    KEYWORDS: '',
                    ABSTRACT: '',
                    ISNOPAYMENT: '1',
                    BELONGCHANNEL: {},
                    RELEVANTOFFICIALSIDS: [],
                    ISCONTAINSENSITIVEWORDS: 0,
                    SENSITIVEWORDS: '',
                    DOCGENRE: angular.copy(editingCenterAppService.initDocGenre()[0]),
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [{ isCreate: true }],
                    HIDDENLABEL: 0, // 签发后隐藏选项
                    CUSTOMTIME: '', // 自定义发布时间
                };
                return list;
            },
            initLive: function() {
                var list = {
                    METADATAID: 0,
                    CHANNELID: $stateParams.appchannelid,
                    THUMB: 1,
                    LIVELABLE: 1,
                    RELEVANTSPECIALDOC: [],
                    TOPICSTARTTIME: '',
                    TOPICENDTIME: '',
                    RELEVANTOFFICIALSIDS: [],
                    LIVESTATUS: 1,
                    ISFOCUSIMAGE: 1,
                    FOCUSIMGTITLE: '',
                    FOCUSIMAGE: [],
                    FOCUSIMAGEDESC: '',
                    URL: '',
                    LISTTITLE: '',
                    LISTPICS: [],
                    BELONGCHANNEL: {},
                    KEYWORDS: '',
                    COMMENTSET: 1,
                    ABSTRACT: '',
                    ISNOPAYMENT: '1',
                    ISCONTAINSENSITIVEWORDS: 0,
                    SENSITIVEWORDS: '',
                    DOCGENRE: angular.copy(editingCenterAppService.initDocGenre()[0]),
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [{ isCreate: true }],
                    HIDDENLABEL: 0, // 签发后隐藏选项
                    LIVETYPE: 0, // 直播类型
                    RELEATELIVEDOCIDS: '', // 相关直播稿件
                    CUSTOMTIME: '', // 自定义发布时间
                };
                return list;
            },
            initTopic: function() {
                var list = {
                    METADATAID: 0,
                    CHANNELID: $stateParams.appchannelid,
                    TITLE: '',
                    LISTPICS: [],
                    LISTTITLE: '',
                    THUMB: 1,
                    TOPICSTARTTIME: '',
                    TOPICENDTIME: '',
                    TOPICGUEST: [],
                    TOPICCOMPERE: [],
                    RELEVANTSPECIALDOC: [],
                    ISFOCUSIMAGE: 1,
                    FOCUSIMGTITLE: '',
                    FOCUSIMAGE: [],
                    FOCUSIMAGEDESC: '',
                    HTMLCONTENT: '',
                    CONTENT: '',
                    COMMENTSET: 1,
                    ISSELECTFIGURE: 0,
                    FIGURE: [],
                    BELONGCHANNEL: {},
                    RELEVANTOFFICIALSIDS: [],
                    KEYWORDS: '',
                    ABSTRACT: '',
                    ISNOPAYMENT: '1',
                    ISCONTAINSENSITIVEWORDS: 0,
                    SENSITIVEWORDS: '',
                    DOCGENRE: angular.copy(editingCenterAppService.initDocGenre()[0]),
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [{ isCreate: true }],
                    HIDDENLABEL: 0, // 签发后隐藏选项
                    CUSTOMTIME: '', // 自定义发布时间
                };
                return list;
            },
            initVideo: function() {
                var list = {
                    METADATAID: 0,
                    CHANNELID: $stateParams.appchannelid,
                    LISTTITLE: '',
                    THUMB: 1,
                    LIVELABLE: 1,
                    RELEVANTSPECIALDOC: [],
                    RELATEDNEWS: '',
                    VIDEOID: '',
                    LISTPICS: [],
                    TITLE: '',
                    ISFOCUSIMAGE: 1,
                    FOCUSIMGTITLE: '',
                    FOCUSIMAGE: [],
                    FOCUSIMAGEDESC: '',
                    HTMLCONTENT: '',
                    CONTENT: '',
                    COMMENTSET: 1,
                    BELONGCHANNEL: {},
                    RELEVANTOFFICIALSIDS: [],
                    LABEL: angular.copy(editingCenterAppService.initLabel()[0].value),
                    NEWSSOURCES: '',
                    SIGNATUREAUTHOR: '',
                    KEYWORDS: '',
                    ABSTRACT: '',
                    URL: '',
                    APPLYSETTING: '',
                    ISNOPAYMENT: '1',
                    ISCONTAINSENSITIVEWORDS: 0,
                    SENSITIVEWORDS: '',
                    DOCGENRE: angular.copy(editingCenterAppService.initDocGenre()[0]),
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [{ isCreate: true }],
                    TOPICCOMPERE: '',
                    VIDEOREL: [],
                    HIDDENLABEL: 0, // 签发后隐藏选项
                    CUSTOMTIME: '', // 自定义发布时间
                    ISLANDSCAPE: 1, // 默认横版视频
                };
                return list;
            },
            initAudio: function() {
                var list = {
                    METADATAID: 0,
                    CHANNELID: $stateParams.appchannelid,
                    LISTTITLE: '',
                    THUMB: 1,
                    LIVELABLE: 1,
                    RELEVANTSPECIALDOC: [],
                    RELATEDNEWS: '',
                    VIDEOID: '',
                    LISTPICS: [],
                    TITLE: '',
                    ISFOCUSIMAGE: 1,
                    FOCUSIMGTITLE: '',
                    FOCUSIMAGE: [],
                    FOCUSIMAGEDESC: '',
                    HTMLCONTENT: '',
                    CONTENT: '',
                    COMMENTSET: 1,
                    BELONGCHANNEL: {},
                    RELEVANTOFFICIALSIDS: [],
                    LABEL: angular.copy(editingCenterAppService.initLabel()[0].value),
                    NEWSSOURCES: '',
                    SIGNATUREAUTHOR: '',
                    KEYWORDS: '',
                    ABSTRACT: '',
                    URL: '',
                    APPLYSETTING: '',
                    ISNOPAYMENT: '1',
                    ISCONTAINSENSITIVEWORDS: 0,
                    SENSITIVEWORDS: '',
                    DOCGENRE: angular.copy(editingCenterAppService.initDocGenre()[0]),
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [{ isCreate: true }],
                    TOPICCOMPERE: '',
                    VIDEOREL: [],
                    HIDDENLABEL: 0, // 签发后隐藏选项
                    CUSTOMTIME: '', // 自定义发布时间
                };
                return list;
            },
        };
    },
]);
